// src/components/admin/AdminDashboard.tsx
import React from 'react';

const AdminDashboard: React.FC = () => {
  return (
    <div>
      <h2>Admin Dashboard Page</h2>
      <p>Welcome to the admin area.</p>
    </div>
  );
};

export default AdminDashboard;